import { Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import successBanner from "../../../../assets/payment_success_banner.svg"
import { MembershipPaymentRoute } from "../../../../views/membership-payment-flow/MembershipPaymentFlow/MembershipPaymentFlow"
import { RecurringPaymentAcknowledgementPageProps } from "../../../../views/recurring-payment-flow/AcknowledgementPage/AcknowledgementPage"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"

const RecurringPaymentSuccessPage = (props: RecurringPaymentAcknowledgementPageProps) => {
    const { orderId, onNavigateTo } = props
    const { t } = useTranslation(`acknowledgement`)

    const handleHomeClick = () => {
        if (window.myNtucConfig.paymentBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.paymentBackToHomeHomeUrl)
        } else {
            onNavigateTo(MembershipPaymentRoute.Main)
        }
    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={successBanner} alt="Payment success banner" />
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`recurring.success.title`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`success.reference`)}</Typography>
                <Typography textAlign="center" data-testid="reference">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6} mt={3} justifyContent='center'>
                <Button onClick={handleHomeClick} variant="contained" color="primary" size="large" sx={{ marginX: 5, marginY: 1 }}>
                    {t(`buttons.home`)}
                </Button>
            </Grid>
        </Grid>
    )
}

export default RecurringPaymentSuccessPage